import { useState } from "react";
import { faqs } from "@/mocks/guaData";

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <p className="flex items-center gap-2 text-sm font-medium text-accent-600">
            <i className="ri-book-open-line"></i>
            吃瓜百科
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            新来的瓜友，常见问题先看这里
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            从什么是吃瓜，到如何参与讨论、订阅瓜报，这些问题都有答案。还有疑问？欢迎在讨论区发帖，老瓜友都会热情解答。
          </p>
          <div className="mt-6 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            <img
              src="https://readdy.ai/api/search-image?query=cozy%20flat%20illustration%20of%20an%20open%20encyclopedia%20book%20with%20colorful%20speech%20bubbles%2C%20small%20melon%20and%20chat%20icons%20floating%20out%2C%20warm%20coral%20amber%20and%20cream%20color%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%20background%2C%20no%20text%2C%20friendly%20educational%20mood&width=880&height=520&seq=faq-gua-01&orientation=landscape&nocache=true"
              alt="翻开的知识书页中飘出对话框和瓜果图案的插画"
              className="h-48 w-full object-cover md:h-56"
              width="880"
              height="520"
            />
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((f, idx) => {
            const isOpen = openId === idx;
            return (
              <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                <h3>
                  <button
                    onClick={() => setOpenId(isOpen ? null : idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="font-medium text-foreground-900">{f.q}</span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"}`}>
                      <i className={isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"}></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="border-t border-background-100 px-5 pb-5 pt-3 text-sm leading-relaxed text-foreground-600">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}